import React, {useEffect} from 'react';
import {Stack, TextField} from '@mui/material';
import createAccountModel from './models/createAccountModel'
import {Field, useFormikContext} from "formik";

const { formField: {createAccountName, createAccountEmail, createAccountPass} } = createAccountModel;

interface OwnProps {
    apiError?: string
}

const CreateAccountForm = (props: OwnProps) => {
    const {errors, touched, setErrors} = useFormikContext<any>();
    useEffect(() => {
        setErrors({[createAccountPass.name]: props.apiError})
    }, [props.apiError, setErrors])

    return (
        <Stack width="100%" spacing={4} pt={4}>
            <Field
            as={TextField}
            fullWidth
            name={createAccountName.name}
            label={createAccountName.label}
            required={createAccountName.required}
            inputProps={{required: false}}
            type="text"
            autoComplete="off"
            error={touched[createAccountName.name] && Boolean(errors[createAccountName.name])}
            helperText={(touched[createAccountName.name] && errors[createAccountName.name]) ? errors[createAccountName.name] : ''}
            />

            <Field
            as={TextField}
            fullWidth
            data-cy={createAccountEmail.name}
            name={createAccountEmail.name}
            label={createAccountEmail.label}
            required={createAccountEmail.required}
            inputProps={{required: false}}
            type="email"
            autoComplete="email"
            error={touched[createAccountEmail.name] && Boolean(errors[createAccountEmail.name])}
            helperText={(touched[createAccountEmail.name] && errors[createAccountEmail.name]) ? errors[createAccountEmail.name] : ''}
            />

            <Field
            as={TextField}
            fullWidth
            name={createAccountPass.name}
            label={createAccountPass.label}
            required={createAccountPass.required}
            inputProps={{required: false}}
            type="password"
            autoComplete="password"
            error={touched[createAccountPass.name] && Boolean(errors[createAccountPass.name])}
            helperText={(touched[createAccountPass.name] && errors[createAccountPass.name]) ? errors[createAccountPass.name] : ''}
            />
        </Stack>
    )
}

export default CreateAccountForm
